module.exports = __webpack_public_path__ + "fonts/AgencyFB-Bold.bad4802a.otf";